import scale from 'media/scale.svg'
import plate from 'media/plate.svg'
import clock from 'media/clock.svg'
import React, { Fragment } from 'react'
import sanitize from 'sanitize'
import PropTypes from 'prop-types'

const RecipeTemplate = props => (
  <Fragment>
    <div className="c-content-area__break-out">
      <div className="c-recipe-facts">
        <ul className="c-recipe-facts__list">
          {props.time && (
            <li className="c-recipe-facts__item">
              <div className="c-recipe-facts__symbol-wrapper">
                <img
                  className="c-recipe-facts__symbol c-recipe-facts__symbol--clock"
                  src={clock}
                  alt=""
                />
              </div>
              <span className="c-recipe-facts__text">{props.time}</span>
            </li>
          )}
          {props.serves && (
            <li className="c-recipe-facts__item">
              <div className="c-recipe-facts__symbol-wrapper">
                <img
                  className="c-recipe-facts__symbol c-recipe-facts__symbol--plate"
                  src={plate}
                  alt=""
                />
              </div>
              <span className="c-recipe-facts__text">
                {props.serves} servings
              </span>
            </li>
          )}
          {props.calories && (
            <li className="c-recipe-facts__item">
              <div className="c-recipe-facts__symbol-wrapper">
                <img
                  className="c-recipe-facts__symbol c-recipe-facts__symbol--scale"
                  src={scale}
                  alt=""
                />
              </div>
              <span className="c-recipe-facts__text">
                {props.calories} calories
              </span>
            </li>
          )}
        </ul>
      </div>
      {props.youtube_video_id && (
        <iframe
          src={`https://www.youtube.com/embed/${props.youtube_video_id}?rel=0&amp;showinfo=0`}
          frameBorder="0"
          width="560"
          height="315"
          allowFullScreen
        />
      )}
      <div className="c-recipe">
        <div className="c-recipe__ingredients s-text">
          <h2 className="c-recipe__heading">Ingredients</h2>
          <div
            dangerouslySetInnerHTML={{
              __html: sanitize(props.recipe_ingredients, {}),
            }}
          />
        </div>
        <div className="c-recipe__instructions">
          <h2 className="c-recipe__heading">Instructions</h2>
          <div
            dangerouslySetInnerHTML={{
              __html: sanitize(props.instructions, {}),
            }}
          />
        </div>
      </div>
    </div>
  </Fragment>
)

RecipeTemplate.propTypes = {
  time: PropTypes.string,
  calories: PropTypes.string,
  serves: PropTypes.string,
  youtube_video_id: PropTypes.string,
  recipe_ingredients: PropTypes.node,
  instructions: PropTypes.node,
}

export default RecipeTemplate
